import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ArrowsDownUp } from "@phosphor-icons/react";

// Options for browsing the whole catalog (Database page)
export const CATALOG_SORT_OPTIONS = [
  { value: "recent", label: "Mais recente" },
  { value: "oldest", label: "Mais antigo" },
  { value: "views", label: "Mais visto" },
  { value: "most_added", label: "Mais adicionado" },
  { value: "alpha", label: "Alfabeticamente" },
];

// Options for personal lists (Coleção / Desejos / Já lidos)
export const LIST_SORT_OPTIONS = [
  { value: "added_recent", label: "Mais recente" },
  { value: "added_oldest", label: "Mais antigo" },
  { value: "views", label: "Mais visto" },
  { value: "most_added", label: "Mais adicionado" },
  { value: "alpha", label: "Alfabeticamente" },
];

export default function SortSelect({ value, onChange, options, testid = "sort-select" }) {
  return (
    <div className="inline-flex items-center gap-2">
      <ArrowsDownUp size={14} weight="bold" className="text-zinc-500" />
      <span className="text-[10px] font-mono-accent text-zinc-500 hidden sm:inline">ORGANIZAR POR</span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-[180px] h-9 bg-[#121217] border-white/10 text-sm" data-testid={testid}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-[#121217] border-white/10 text-white">
          {options.map(opt => (
            <SelectItem key={opt.value} value={opt.value} data-testid={`${testid}-opt-${opt.value}`}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
